<template>
    <div class="login-container">
        <div class="login-card">
            <div class="login-header">
                <img src="@/assets/logo-ad4.png" alt="Logo">
                <h2>Campaign Manager</h2>
            </div>
            <div v-if="data.Code != 'OK'">
                <form @submit.prevent="loginForm" class="login-form">
                    <div class="field">
                        <label>E-mail address</label>
                        <input v-model="form.email" type="email" placeholder="enter your email address" required>
                    </div>
                    <div class="t-holder">
                        <span>Link will be sent to given email address.</span>
                    </div>
                    <button type="submit" class="btn-login">Sign in</button>
                </form>
            </div>
            <div>
                <div class="msg msg-ok" v-if="data.Code === 'OK'">
                    <p>Link has been sent to your email address.</p>
                </div>
                <div class="msg msg-err" v-else>
                    <p>{{data.Text}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import authService from "@/services/auth.js";
import { useConfigStore } from "@/store/config";


export default {
    name: "LoginView",
    data() {
        return {
            form: {
                email: ''
            },
            data: {}
        };
    },
    mounted() {
        const authStore = useConfigStore();

        console.log(authStore.userID);
        console.log(authStore.userFirstName);
        console.log(authStore.userLastName);

        if (authStore.isLoggedIn) {
            this.$router.push("/home");
        }
    },
    methods: {
        // handleLogin() {
        //     console.log('Dane logowania:', this.form);
        //     alert('Zalogowano: ' + this.form.email);
        //     this.$router.push('/home');
        // }
        async loginForm() {
            this.data = await authService.createLoginPost(this.form);
            console.log(this.data);
        }
    }
}
</script>

<style scoped>
.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: var(--bg-page);
}

.login-card {
    background: white;
    padding: 40px 40px 48px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px;
    text-align: center;
    position: relative;
}

.login-header {
    text-align: center;
    margin-bottom: 32px;
}

.login-header img {
    max-width: 150px;
    margin-bottom: 16px;
}

.login-header h2 {
    margin: 0;
    font-size: 24px;
}

.field, .t-holder {
    margin-bottom: 24px;
}

.field label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 14.4px;
}

.field input {
    width: 100%;
    padding: 12px;
    border: 1px solid var(--border);
    border-radius: 8px;
    font-size: 16px;
}

.t-holder span {
    font-size: 12.8px;
    color: var(--text-muted);
}

.btn-login {
    width: 100%;
    padding: 12px;
    background: var(--orange);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: 0.2s;
}

.btn-login:hover {
    background: var(--orange-dark);
}

.msg {
    color: rgb(184, 15, 15);
    font-size: 12px;   
}

.msg-ok {    
    color: #0072bb;
    font-size: 14px;
}

.msg-err {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: 10px;
}


</style>